import React from 'react';
import { SerialProcessingHookReturnType } from '../../../../hooks/useSerialProcessing';
import { useApproveTimeEntryChangeRequestSerial } from './useApproveTimeEntryChangeRequestSerial';
import { useRejectTimeEntryChangeRequestSerial } from './useRejectTimeEntryChangeRequestSerial';

type ContextType = {
  approveMutation: SerialProcessingHookReturnType;
  rejectMutation: SerialProcessingHookReturnType;
};

const defaultValueSerialProcessing: SerialProcessingHookReturnType = {
  processItem: (id) => {
    throw new Error('TimeTrackingContextProvider is not setup');
  },
  processingIds: [],
};

const defaultValue: ContextType = {
  approveMutation: defaultValueSerialProcessing,
  rejectMutation: defaultValueSerialProcessing,
};

export const TimeTrackingMutationsContext =
  React.createContext<ContextType>(defaultValue);

export const TimeTrackingMutationsContextProvider: React.FC = (props) => {
  const approveMutation = useApproveTimeEntryChangeRequestSerial();
  const rejectMutation = useRejectTimeEntryChangeRequestSerial();

  return (
    <TimeTrackingMutationsContext.Provider
      value={{
        approveMutation,
        rejectMutation,
      }}
      {...props}></TimeTrackingMutationsContext.Provider>
  );
};
